import { post,get,getJ,put,deleteJ,getExcel,uploadFile,uploadSort,upload,postOther,getPDF,deletes,importExcel } from '@/utils/axios'

export default {
    
    //创建后台资源
    WorkOrderAdd(datas){
        return post('WorkOrder/Add',datas)
    },
    //删除资源
    WorkOrderUpdate(datas){
        return put('WorkOrder/Update',datas)
    },
    //获取所有菜单资源
    WorkOrderDelete(datas){
        return deleteJ('WorkOrder/Delete',datas)
    },
    //修改权限
    WorkOrderList(datas){
        return get('WorkOrder/QueryPager',datas)
    },
    
}